import React from 'react';
import classNames from 'classnames';
import { Icon, TextInput } from '@doxyme/ui';
export function SeatsSelector({ value, onChange, min = 1, max = 9999, }) {
    const isMinusButtonDisabled = value <= min;
    const decreaseSeats = () => {
        if (value > min) {
            onChange(value - 1);
        }
    };
    const increaseSeats = () => {
        if (value < max) {
            onChange(value + 1);
        }
    };
    const handleInputChange = (e) => {
        const newValue = Number(e.target.value);
        if (!Number.isNaN(newValue) && newValue >= min && newValue <= max) {
            onChange(newValue);
        }
    };
    return (<div className="payment-setup__seats-widget-container">
      <button className={classNames('payment-setup-minus-button', {
            'payment-setup-minus-button--disabled': isMinusButtonDisabled,
        })} type="button" disabled={isMinusButtonDisabled} onClick={decreaseSeats} aria-label="Decrease seats">
        <div className={classNames('payment-setup__minus-icon', {
            'payment-setup__minus-icon--disabled': isMinusButtonDisabled,
        })}/>
      </button>

      <TextInput type="number" name="newSeatsNumber" className="payment-setup__seats-value-container" value={value} onChange={handleInputChange}/>

      <button className="payment-setup-plus-button" type="button" onClick={increaseSeats}>
        <Icon className="payment-setup__plus-icon" name="plus"/>
      </button>
    </div>);
}
